import { createStore } from 'effector';

import { FileResult } from 'models/File';

export const $image = createStore<FileResult | null>({ fileName: '', contentType: '', absoluteUri: '' });
